module.exports = __webpack_public_path__ + "media/images/about/a1-6e3e9f267ff250ded65a0361fae738c6.png";